import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Tab,Col,Nav,Row} from 'react-bootstrap';
import { format } from 'date-fns';
import {userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../../configs/urlConfigs';
import { MSG_RECORDED_ADDED_SUCCESS,MSG_NOT_FOUND,MSG_NO_INPUT_PROVIDED,MSG_RECORDED_DELETE_SUCCESS,MSG_RECORDED_UPDATED_SUCCESS,MSG_DELETE_VECHICLE_DETAILS,MSG_DYNAMIC_FIELD_NAME_REQUIRED,MSG_DYNAMIC_FIELD_TYPE_REQUIRED} from '../../../configs/msgConfigs';
import { LBL_APPROVED,LBL_ACTIONS,LBL_EDIT,LBL_DELETE,LBL_EDIT_VEHICLE,LBL_ADD_VEHICLE,LBL_ADD_VEHICLE_FIELDS,LBL_AFFILIATE_VEHICLE_LIST,LBL_SAVE,LBL_BTN_ADDNEW,LBL_SLNUM,LBL_FIELD_NAME,LBL_FIELD_TYPE,LBL_CREW_VISIBILITY,LBL_CLIENT_VISIBILITY,LBL_MANDATORY_FIELD,LBL_SHO,LBL_VEHICLE_INFO,LBL_APP_NAME,LBL_SETTINGS,LBL_YES,LBL_NO,LBL_CONFIRM_DELETE} from '../../../configs/labelConfigs';
import { TAB1,TAB2,DYNAMIC_FIELDS_TYPES,DELETE_SYMBOL} from '../../../configs/staticConfigs';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';
import { clearAction} from '../../../actions/commonActions';
import {format as stringFormat} from 'react-string-format';
import { converDateToLocal,convertDecimalToHHMM,convertHHMMToDecimal } from '../../../utils/commonUtilities';
import { listFieldDetails,saveFieldDetails,saveVehicleInfo,listVehicleInfo,deleteVehicleInfo,updateVehicleInfo,getVehicleInfo} from '../../../actions/settings/affiliates/vehicleInfoAction';
import { GET_VEHICLE_INFO_SUCCESS,LIST_FIELD_DETAILS_SUCCESS,SAVE_FIELD_DETAILS_SUCCESS,SAVE_VEHICLE_INFO_SUCCESS,LIST_VEHICLE_INFO_SUCCESS,UPDATE_VEHICLE_INFO_SUCCESS,DELETE_VEHICLE_INFO_SUCCESS} from '../../../actions'; 

class AffiliateVehicleInfo extends Component { 

    constructor(props){
        super(props)
        this.vehicleDetailsModal = React.createRef();
        let userGroupData = userGroupUrlCheck(this.props.location);
        let profileId = '';
        if(userGroupData!==undefined){
            profileId = userGroupData.profile_id;
        }
        let timeZone =  getUserTimeZone(this.props.location);
        this.state = {
            formErrors : {},
            infoFormErrors : {},
            commonErrMsg:'',
            valueErrMsg:'',
            fieldDetails:[],
            affiliate:parseInt(profileId),
            toastMessagePop:'',
            toastFlagPop:false,
            toastSuccessPop:true,
            vehicleDetailsHeader:LBL_ADD_VEHICLE,
            vehicleInfoDetailedList:[],
            vehicleInfoValue:{},
            activeRowId:0,
            deleteId:0,
            timeZone:timeZone,
            editId:0
        }
        this.modalDelete = React.createRef();
    }

    onCloseToastPop = () =>{ // USED FOR POPUP clientContactAdd
        this.setState({toastFlagPop:false,toastMessagePop:'',toastSuccessPop:false});
    } 

    setToasterStatePop = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlagPop:isEnabled,toastMessagePop:message,toastSuccessPop:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToastPop();
            }, 3000);
        }    
    }

    componentDidMount() {
        document.body.classList.add('body-affiliate');
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_VEHICLE_INFO;
        //this.props.listFieldDetails();
        this.props.listVehicleInfo();
    }

    componentDidUpdate(prevProps) {  
        let {vehicleInfoActivity,vehicleInfoStatus,fieldDetailsList,vehicleInfoList,vehicleInfoRetrieve} = this.props;
        if (vehicleInfoActivity && (vehicleInfoStatus !== prevProps.status || vehicleInfoActivity!==prevProps.activity)) {
            var arrResp = vehicleInfoActivity.split('~~'); 
            var actString = arrResp[0]; 
            if(actString===LIST_FIELD_DETAILS_SUCCESS) { 
                this.setInfoFormError();
                this.props.clearAction();
                let field_details = []
                let {formErrors} = this.state;

                fieldDetailsList.map((item,index)=>{
                    item.field_id = index;
                    field_details.push(item)
                })
                if(fieldDetailsList.length === 0){
                    formErrors.fieldEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED;
                    formErrors.fieldTypeEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED;
                    field_details.push({ field_id:0, id:"", field_name:'', field_type: '', is_mandatory: false, crew_visibility:false,client_visibility:false,affiliate:this.state.affiliate}); 
                }
                this.setState({fieldDetails:field_details,formErrors:formErrors});
            }
            if(actString===SAVE_FIELD_DETAILS_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_RECORDED_ADDED_SUCCESS,true);
                // this.props.listFieldDetails();
            }
            if(actString===LIST_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
            }
            if(actString===SAVE_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_RECORDED_ADDED_SUCCESS,true);
                this.props.listVehicleInfo();
            }
            if(actString===UPDATE_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_RECORDED_UPDATED_SUCCESS,true);
                this.props.listVehicleInfo();
            }
            if(actString===DELETE_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_RECORDED_DELETE_SUCCESS,true);
                this.props.listVehicleInfo();
            }
            if(actString===GET_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                let vehicleInfoValue = {}
                let {infoFormErrors} = this.state;
                vehicleInfoRetrieve.affiliatevehicledetails_set.map((item,index)=>{
                    let value = '';
                    fieldDetailsList.map((fieldItem,fieldIndex)=>{
                        if(fieldItem.id === item.field_info){
                            if(fieldItem.field_type === 'string'){
                                value = item.text_value;

                            }else{
                                 value = new Date(converDateToLocal(item.date_value,this.state.timeZone.utc_offset,'yyyymmdd'));
                            }
                        }
                        
                    })
                    
                    vehicleInfoValue[item.field_info]=value;
                    
                    if(Object.keys(infoFormErrors).indexOf(item.field_info.toString()) !== -1){
                        if(value === '' | value === null){
                            infoFormErrors[item.field_info] = "input-error";
                        }else{
                            infoFormErrors[item.field_info] = "";
                        }
                    }
                })
                vehicleInfoValue['is_approved'] = vehicleInfoRetrieve.is_approved;
                this.setState({vehicleInfoValue:vehicleInfoValue,infoFormErrors:infoFormErrors},()=>{
                    this.vehicleDetailsModal.current.handleOpenModal(); 
                })
            }
        }
        
    }

    onTabChange(e,tab){
        if(tab===TAB1) { 
            this.props.listVehicleInfo();
        }
        else if(tab===TAB2) { 
            // this.props.listFieldDetails();
        }
    }

    addNewRow = (e) => {
        let newfieldObj = this.state.fieldDetails;
        let {formErrors} = this.state;
        let field_id = 0;
        if(newfieldObj.length>0){
            field_id = newfieldObj[newfieldObj.length-1].field_id + 1
        }
        newfieldObj.push({ field_id:field_id, id:"", field_name:'', field_type: '', is_mandatory: false, crew_visibility:false,client_visibility:false,affiliate:this.state.affiliate}); 
        
        formErrors.fieldEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED
        formErrors.fieldTypeEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED
        this.setState({fieldDetails:newfieldObj,formErrors:formErrors}); 
    }
    deleteBtnClick = (e,field_id) =>{
        let newfieldObj = this.state.fieldDetails;
        let formErrors      = this.state.formErrors;
        let newRows = newfieldObj.filter(item => item.field_id!==field_id);
        this.setState({fieldDetails:newRows});
    }
    onSaveFieldDetails = (e) =>{
        if(this.state.fieldDetails.length === 0 || (!this.state.formErrors.fieldEmpty && !this.state.formErrors.fieldTypeEmpty)){
            let newfieldObj = this.state.fieldDetails;
            newfieldObj.map((item,index)=>{
                if(item.id===''){
                    delete item["id"];
                }
                delete item["field_id"];
            });
        
            this.props.saveFieldDetails(newfieldObj);
        }
    }
    onHandleChange = (e, fieldIndex,fieldName) =>{
        const valStr = e.target.type === "checkbox" ? e.target.checked : e.target.value;  
        let formErrors      = this.state.formErrors;
        let fieldDetails    = this.state.fieldDetails;  
        
        if(fieldName==='field_name') { 
            formErrors.fieldEmpty = ''; 
            if(valStr==='')  formErrors.fieldEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED; 
            fieldDetails.map((item,index)=>{
                if(item.field_id === fieldIndex){
                    item.field_name = valStr; 
                }
                
            })
            this.setState({fieldDetails:fieldDetails, formErrors:formErrors});  
        } 
        else if(fieldName==='field_type') { 
            formErrors.fieldTypeEmpty = ''; 
            if(valStr==='')  formErrors.fieldTypeEmpty = MSG_DYNAMIC_FIELD_TYPE_REQUIRED; 
            fieldDetails.map((item,index)=>{
                if(item.field_id === fieldIndex){
                    item.field_type = valStr; 
                }
                
            })
            this.setState({fieldDetails:fieldDetails, formErrors:formErrors});  
        }
        else if(fieldName==='is_mandatory') { 
            fieldDetails.map((item,index)=>{
                if(item.field_id === fieldIndex){
                    item.is_mandatory = valStr; 
                }
                
            })
            this.setState({fieldDetails:fieldDetails});  
        }
        else if(fieldName==='crew_visibility') { 
            fieldDetails.map((item,index)=>{
                if(item.field_id === fieldIndex){
                    item.crew_visibility = valStr; 
                }
                
            })
            this.setState({fieldDetails:fieldDetails});  
        }
        else if(fieldName==='client_visibility') { 
            fieldDetails.map((item,index)=>{
                if(item.field_id === fieldIndex){
                    item.client_visibility = valStr; 
                }
                
            })
            this.setState({fieldDetails:fieldDetails});  
        }
    }

    onHandleVehicleInfoChange = (e,item,type) =>{
        let value = '';
        let {vehicleInfoValue,infoFormErrors} = this.state;
        if(type==='string'){
            value = e.target.value;
        }else{
            if(e === '' || e === null){
                value = new Date();
            }else{
                value = new Date(e);
            }
        }
        vehicleInfoValue[item.id] = value;
        if(Object.keys(infoFormErrors).indexOf(item.id.toString()) !== -1){
            if(value==="" || value === null){
                infoFormErrors[item.id] = "input-error";
            }else{
                infoFormErrors[item.id] = "";
            }

        }
        this.setState({vehicleInfoValue:vehicleInfoValue,infoFormErrors:infoFormErrors})
    }

    //Add details part
    addVehicleDetails = (e) =>{
        this.setInfoFormError();
        this.setState({editId:0,vehicleDetailsHeader:LBL_ADD_VEHICLE,vehicleInfoValue:{}},()=>{
            this.vehicleDetailsModal.current.handleOpenModal();
        }) 
    }
    
    setInfoFormError = ()=>{
        let infoFormErrors = {};
        console.log('this.props.fieldDetailsList',JSON.stringify(this.props.fieldDetailsList)); 
        this.props.fieldDetailsList.map((item,index)=>{
            if(item.is_mandatory){
              infoFormErrors[item.id] = "input-error";  
            }
            
        })
        this.setState({infoFormErrors:infoFormErrors})
    }
    onSaveFormData = (e) =>{
        let {vehicleInfoValue} = this.state;
        let {fieldDetailsList} = this.props;
        let flag = true;
        Object.values(vehicleInfoValue).map((item,index) =>{
            if(item !== "" || item !== null){
                flag = false;
            }
        });
        Object.values(this.state.infoFormErrors).map((item,index)=>{
            if(item === 'input-error'){
                flag = true;
            }
        })
        if(flag){
            this.setState({valueErrMsg:MSG_NO_INPUT_PROVIDED})
        }else{
            let vehicleSaveObj = [];
            fieldDetailsList.map((fieldItem,fieldIndex)=>{
                if(Object.keys(vehicleInfoValue).indexOf(fieldItem.id.toString()) !== -1){

                    let text_value = '';
                    let date_value = null;
                    if(fieldItem.field_type === 'string'){
                        text_value = vehicleInfoValue[fieldItem.id]
                    }else{
                        date_value = format(vehicleInfoValue[fieldItem.id],'yyyy-MM-dd')
                    }
                    vehicleSaveObj.push({"field_name":fieldItem.field_name,"text_value":text_value,
                                            "date_value":date_value,"field_info":fieldItem.id})
                }

            })
            if(this.state.editId!==0){
                this.props.vehicleInfoRetrieve.affiliatevehicledetails_set.map((item,index)=>{
                    vehicleSaveObj.map((vehItem,index)=>{
                        if(vehItem.field_info === item.field_info){
                            vehItem['id'] = item.id
                        }
                    })
                })
                this.props.updateVehicleInfo({id:this.state.editId,vehicle_details:vehicleSaveObj,is_approved:vehicleInfoValue.is_approved})
            }else{
                this.props.saveVehicleInfo({vehicle_details:vehicleSaveObj,is_approved:vehicleInfoValue.is_approved});
            }
            this.vehicleDetailsModal.current.handleModelClose()
        }


    }
    onModalFormReset = (e) =>{  
      // this.vehicleDetailsModal.current.handleCloseModal();       

    }
    onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus(); 
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus(); 
      } 
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   editVehicleBtnClick = (e,id) =>{
        this.setInfoFormError();
        this.props.getVehicleInfo(id);
        this.setState({editId:id,vehicleDetailsHeader:LBL_EDIT_VEHICLE});
   }
   deleteVehicleBtnClick = (e,id) =>{
        this.setState({deleteId:id},()=>{
            this.modalDelete.current.handleOpenModal(); 
        });
   }
   onDeleteAction =()=>{
        this.props.deleteVehicleInfo(this.state.deleteId);
        this.modalDelete.current.handleModelClose();
   }
   onHandleIsApprovedChange =(e)=>{
        let {vehicleInfoValue} = this.state;
        let checked = e.target.checked;
        vehicleInfoValue['is_approved'] = checked;
        this.setState({vehicleInfoValue:vehicleInfoValue})
   }
       
    render(){
        let {fieldDetails, toastMessagePop, toastSuccessPop, toastFlagPop} = this.state;
        let fieldId = '';
        let dtVal = '';
        let newDate = new Date();
        let timeZone =  getUserTimeZone(this.props.location);
        let userGroupData = userGroupUrlCheck(this.props.location);
        let lblCrew = 'Staff'
        if(userGroupData!==undefined){
            if(userGroupData.staff_name){
                lblCrew = userGroupData.staff_name; 
            }
        }
        console.log(this.state.infoFormErrors);
        return(
                <React.Fragment>
                    <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToastPop} />
                    <Tab.Container id="profile-tab" defaultActiveKey="vehicle-list">
                    <Col md={4} lg={2}>
                        <Nav variant="pills" className="nav flex-column nav-pills box">

                            <Nav.Link onClick={(e) => this.onTabChange(e, TAB1)} eventKey="vehicle-list">{/*<i className="la la-cube"></i>*/}<small>{LBL_AFFILIATE_VEHICLE_LIST}</small></Nav.Link>

                            <Nav.Link onClick={(e) => this.onTabChange(e, TAB2)} eventKey="dynamic-fields">{/*<i className="las la-user-astronaut"></i>*/}<small>Dynamic Fields Settings</small></Nav.Link>

                        </Nav>
                    </Col>
                    <Col md={9} lg={8} className="space-reducer right-content">
                        <Tab.Content>
                            <Tab.Pane eventKey="vehicle-list">
                                <div className="box">
                                    {this.props.fieldDetailsList.length > 0 && <div className="tab-head tdVeticalMiddle">
                                        <div className="float-left tdVeticalMiddle btn marginLeft0"><h6>{LBL_AFFILIATE_VEHICLE_LIST}</h6></div>
                                        <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addVehicleDetails(e)} >{LBL_BTN_ADDNEW}</button></div>
                                    </div>}
                                     <div className="box-content">
                                         <div className="table-responsive">
                                         {this.props.fieldDetailsList.length > 0 && 
                                            <><table id="data-table" className="table" style={{width:"100%"}}>
                                               <thead>
                                                  <tr> 
                                                     <th className="text-center">{LBL_SLNUM}</th>
                                                     {this.props.fieldDetailsList.map((item,index)=>{
                                                            return(
                                                                <th key={index} className="text-center">{item.field_name}</th>
                                                            )
                                                         })
                                                     }
                                                     <th className="text-center ">{LBL_APPROVED}</th>
                                                     <th className="max-width-100">{LBL_ACTIONS}</th>
                                                  </tr>
                                               </thead>
                                               <tbody>
                                               {this.props.vehicleInfoList.length === 0 && 
                                                    <tr>
                                                        <td colSpan={this.props.fieldDetailsList.length?this.props.fieldDetailsList.length+2:1} className="text-center">{MSG_NOT_FOUND}</td>
                                                    </tr>
                                               }
                                               {this.props.vehicleInfoList.length > 0 && this.props.vehicleInfoList.map((item,index)=>{
                                                return(
                                                    <tr key={index}>
                                                        <td className="text-center">
                                                            {index+1}
                                                        </td>
                                                        {this.props.fieldDetailsList.map((fieldItem,fieldIndex)=>{
                                                            let value = ''

                                                            item.affiliatevehicledetails_set.map((valItem,valIndex)=>{

                                                                if(valItem.field_info === fieldItem.id){
                                                                    if(fieldItem.field_type==='string'){
                                                                      value = valItem.text_value  
                                                                    }else{
                                                                        value = converDateToLocal(valItem.date_value,timeZone.utc_offset,'ddmmyyyy');
                                                                    }
                                                                   
                                                                }
                                                            })

                                                            return (<td key={fieldIndex} className="text-center">
                                                                        {value}
                                                                    </td>
                                                            )
                                                        })}

                                                        <td className="text-center">
                                                            {item.is_approved?LBL_YES:LBL_NO}
                                                        </td>

                                                        <td className="max-width-100">
                                                            <div className={"dropdown"} id={'dropdown-'+index}>
                                                               <button className="dropdown-toggle" type="button"
                                                                  id={'dropdownMenuButton-'+index} data-toggle="dropdown"
                                                                  aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, index)} >
                                                                  <input type="image" id={"img-action-"+index} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, index)} ></input>
                                                               </button>
                                                               <div className="dropdown-menu" id={'dropdown-menu-'+index}
                                                                  aria-labelledby={'dropdownMenuButton-'+index}>
                                                                     <Link className="dropdown-item edit" to="#" onMouseDown={(e) =>  this.editVehicleBtnClick(e, item.id)}>{LBL_EDIT}</Link> 
                                                                     <Link className="dropdown-item delete" to="#" onMouseDown={(e) =>  this.deleteVehicleBtnClick(e, item.id)}>{LBL_DELETE}</Link> 
                                                                     
                                                               </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )

                                               })

                                               }                                
                                               </tbody>
                                            </table>
                                            <div className="clear-b-scroll-sector">&nbsp;</div>
                                            <div className="clear-b-scroll-sector">&nbsp;</div></>   
                                        }
                                          {this.props.fieldDetailsList.length === 0 && 
                                            <table id="data-table" className="table" style={{width:"100%"}}>
                                                  <tr> 
                                                     <td colSpan="13" className="text-center">{MSG_NOT_FOUND}</td>
                                                  </tr>                                
                                            </table>
                                          }  
                                        </div>                                
                                    </div>                                
                                </div>                                
                            </Tab.Pane>
                            <Tab.Pane eventKey="dynamic-fields">
                               <div className="box">
                                    <div className="tab-head tdVeticalMiddle">
                                        <div className="float-left tdVeticalMiddle btn marginLeft0"><h6>{LBL_ADD_VEHICLE_FIELDS}</h6></div>
                                        <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow(e)} >{LBL_BTN_ADDNEW}</button></div>
                                    </div>
                                    <div className="box-content">
                                    <div className="table-responsive">
                                        {this.state.fieldDetails && 
                                        <table id="data-table" className='table dynTable'  >
                                            <thead className="text-bold">
                                            <tr>
                                                <th className="text-center ">{LBL_SLNUM}</th>
                                                <th className="text-center ">{LBL_FIELD_NAME}</th>
                                                <th className="text-center ">{LBL_FIELD_TYPE}</th>
                                                <th className="text-center ">{stringFormat(LBL_CREW_VISIBILITY,lblCrew)}</th>
                                                <th className="text-center ">{LBL_CLIENT_VISIBILITY}</th>
                                                <th className="text-center ">{LBL_MANDATORY_FIELD}</th>
                                                <th className="text-center "></th>
                                            </tr>
                                            </thead> 
                                            <tbody>
                                            
                                            {fieldDetails.map( (fieldObj,fieldIndex) => {  
                                                return( 
                                                    <tr key={fieldObj.field_id}> 
                                                    
                                                        <td className="text-center">{fieldIndex+1}</td>
                                                        <td className="text-center tdVeticalMiddle"> 
                                                            <div className="form-group text-input tdVeticalMiddle">
                                                            <input name={"txt_fieldName_"+fieldObj.field_id} value={fieldObj.field_name} onChange={(e) => this.onHandleChange(e,fieldObj.field_id,'field_name')} maxLength = {120} className={fieldObj.field_name.trim()==='' ? "input-error" : ''} /> 
                                                            </div>
                                                        </td>

                                                        <td className="text-center"> 
                                                            <div className="form-group select-input">
                                                            <select name={"sel_fieldType_"+fieldObj.field_id} onChange={(e) => this.onHandleChange(e,fieldObj.field_id,'field_type')} value={fieldObj.field_type} className={fieldObj.field_type.trim()==='' ? "input-error" : ''} >
                                                                <option key={fieldObj.field_id+'_'+fieldIndex+'_0'} value=''>Select</option>
                                                                {DYNAMIC_FIELDS_TYPES.map((item,selIndex) => <option key={fieldObj.field_id+'_'+selIndex} value={item.value}>{item.code}</option>)}                                     
                                                            </select>
                                                            </div>
                                                        </td>
                                                        <td className="text-center"> 
                                                            <div className="custom-checkbox">
                                                                <input name={"chk_fieldCrewVisibility_"+fieldObj.field_id} type="checkbox" id={"chk_fieldCrewVisibility_"+fieldObj.field_id}  checked={fieldObj.crew_visibility} onChange={(e) => this.onHandleChange(e,fieldObj.field_id,'crew_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldCrewVisibility_"+fieldObj.field_id}></label> 
                                                            </div>
                                                        </td>
                                                        <td className="text-center"> 
                                                            <div className="custom-checkbox">
                                                                <input name={"chk_fieldClientVisibility_"+fieldObj.field_id} type="checkbox" id={"chk_fieldClientVisibility_"+fieldObj.field_id}  checked={fieldObj.client_visibility} onChange={(e) => this.onHandleChange(e,fieldObj.field_id,'client_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldClientVisibility_"+fieldObj.field_id}></label> 
                                                            </div>
                                                        </td>
                                                        <td className="text-center"> 
                                                            <div className="custom-checkbox">
                                                                <input name={"chk_fieldMandatory_"+fieldObj.field_id} type="checkbox" id={"chk_fieldMandatory_"+fieldObj.field_id}  checked={fieldObj.is_mandatory} onChange={(e) => this.onHandleChange(e,fieldObj.field_id,'is_mandatory')} /> <label className="checkbox" htmlFor={"chk_fieldMandatory_"+fieldObj.field_id}></label> {/* <label className="labeltext" htmlFor={"chk_fieldMandatory_"+fieldObj.field_id}>{LBL_FIELD_MANDATORY}</label> */}
                                                            </div>
                                                        </td>
                                                        <td className="text-center"><i className={DELETE_SYMBOL} title='Remove this Row' onMouseDown={(e)=>this.deleteBtnClick(e, fieldObj.field_id)} ></i>&nbsp;</td>

                                                    </tr>
                                                )  // DYNAMIC_FIELDS_TYPES 
                                            }
                                            )}
                                            </tbody>
                                        </table>
                                        }    
                                        </div>
                                    </div> 
                                    
                                    <div className="tab-head col-12">
                                        {this.state.commonErrMsg.length >0 && (
                                        <div className="text-red text-12 text-right">{this.state.commonErrMsg}</div> )} 
                                            
                                        <div className="float-right">  
                                        <button  type="button" className="btn btn-primary saveBtnMinWidth" onClick={(e) => this.onSaveFieldDetails(e)} >{LBL_SAVE}</button></div>  
                                        </div>
                                </div>
                            </Tab.Pane>
                            
                        </Tab.Content>
                    </Col>
                </Tab.Container>

                
                <ModalWindow modalId="vehicleDetailsModal" ref={this.vehicleDetailsModal} header={this.state.vehicleDetailsHeader} saveFormData={ (e)=>this.onSaveFormData(e)} resetModalForm={(e) => this.onModalFormReset(e)} type="save" >
                    <Row>
                        {this.props.fieldDetailsList.length > 0 && this.props.fieldDetailsList.map((item,index) => {  
                            fieldId = item.id; 
                            return(
                                <Col md={6} key={index} className={item.field_type==='date'?'margin-bottom-20':''}>
                                    <div className="form-group">
                                        <label>{item.field_name}</label>
                                        <div className="input-input">
                                            <React.Fragment> 
                                                { (item.field_type==='string') && 
                                                    <input type="text" name={"txt_fieldValue_"+fieldId} value={this.state.vehicleInfoValue[fieldId]?this.state.vehicleInfoValue[fieldId]:''} onChange={(e) => this.onHandleVehicleInfoChange(e,item,'string')}  className={this.state.infoFormErrors[fieldId]? this.state.infoFormErrors[fieldId]:'' }/>
                                                }
                                                
                                                { (item.field_type==='date') && 
                                                    <DatePicker 
                                                        selected={this.state.vehicleInfoValue[fieldId]?this.state.vehicleInfoValue[fieldId]:newDate}
                                                        onChange={dateVal => this.onHandleVehicleInfoChange(dateVal,item,'date')}
                                                        
                                                        placeholderText="Select a Date"
                                                        className={this.state.infoFormErrors[fieldId]? this.state.infoFormErrors[fieldId]: ""} 
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        fixedHeight   
                                                        autoComplete="off"
                                                        dateFormat={'dd/MM/yyyy'}
                                                    /> 
                                                }
                                                
                                            </React.Fragment>
                                            
                                        </div>
                                    </div>
                                </Col>)
                            } ) }
                        </Row>
                        <Row>
                            <Col md={6} >
                                <div className="custom-checkbox">
                                    <input name={"chk_is_approved"} type="checkbox" id={"chk_is_approved"}  checked={this.state.vehicleInfoValue.is_approved} onChange={(e) => this.onHandleIsApprovedChange(e)} /> <label className="checkbox" htmlFor={"chk_is_approved"}></label> 
                                    <label className="labeltext" htmlFor="chk_is_approved">{LBL_APPROVED}</label>
                                </div>
                            </Col>
                        </Row>
                </ModalWindow> 
                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {MSG_DELETE_VECHICLE_DETAILS}
               </ModalWindow>
                </React.Fragment>
            
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fieldDetailsList:state.vehicleInfoData.fieldDetailsList,
        vehicleInfoList:state.vehicleInfoData.vehicleInfoList,
        vehicleInfoStatus:state.vehicleInfoData.vehicleInfoStatus,
        vehicleInfoActivity:state.vehicleInfoData.vehicleInfoActivity,
        fieldDetailsSavedList:state.vehicleInfoData.fieldDetailsSavedList,
        vehicleInfoRetrieve:state.vehicleInfoData.vehicleInfoRetrieve
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        listFieldDetails:listFieldDetails,
        saveFieldDetails:saveFieldDetails,
        saveVehicleInfo:saveVehicleInfo,
        listVehicleInfo:listVehicleInfo,
        deleteVehicleInfo:deleteVehicleInfo,
        updateVehicleInfo:updateVehicleInfo,
        getVehicleInfo:getVehicleInfo,
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(AffiliateVehicleInfo);
